import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import HowToUsePage from "../pages/how-to-use/page";
import SafetyGuidePage from "../pages/safety-guide/page";
import VsAgentsPage from "../pages/vs-agents/page";
import PriceGuidePage from "../pages/price-guide/page";
import BeginnersPage from "../pages/beginners/page";
import CategoriesPage from "../pages/categories/page";
import TipsPage from "../pages/tips/page";
import FAQArticlePage from "../pages/faq-article/page";
import ReviewPage from "../pages/review/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/itaobuyspreadsheet-guide", element: <ArticlePage /> },
  { path: "/itaobuyspreadsheet-how-to-use", element: <HowToUsePage /> },
  { path: "/itaobuyspreadsheet-safety-guide", element: <SafetyGuidePage /> },
  { path: "/itaobuyspreadsheet-vs-agents", element: <VsAgentsPage /> },
  { path: "/itaobuyspreadsheet-price-guide", element: <PriceGuidePage /> },
  { path: "/itaobuyspreadsheet-beginners", element: <BeginnersPage /> },
  { path: "/itaobuyspreadsheet-categories", element: <CategoriesPage /> },
  { path: "/itaobuyspreadsheet-tips", element: <TipsPage /> },
  { path: "/itaobuyspreadsheet-faq", element: <FAQArticlePage /> },
  { path: "/itaobuyspreadsheet-review", element: <ReviewPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;